import { colors, Button } from '@insurancemenu/imenu-components-lib';
import { NotificationImportant } from '@insurancemenu/imenu-components-lib/dist/icons';
import clsx from 'clsx';
import React from 'react';
import { createStyles } from './styles';

interface BatchWarningProps {
  show: boolean;
  title: string;
  onClose: () => void;
  alignment?: 'left' | 'right' | 'center';
}

const BatchWarning = ({ show, title, alignment = 'left', onClose }: BatchWarningProps): JSX.Element => {
  const classes = createStyles();
  return (
    <div className={show ? clsx(classes.show, classes.modal, classes[`${alignment}Alignment`]) : classes.hide}>
      <div className={classes.warningContent}>
        <NotificationImportant width="4.5rem" height="4.5rem" color={colors.orange[600]} className={classes.icon} />
        <p className={classes.warningText}>{title}</p>
        <Button color="primary" type="outlined" className={classes.cancelWarningModalBtn} onClick={onClose}>
          Close
        </Button>
      </div>
    </div>
  );
};

export default BatchWarning;
